module.exports = __webpack_public_path__ + "img/icon_cat_query.8372ef6.png";